var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noticeService"},[_c('transition',{attrs:{"name":"notice","mode":"in-out"}},[(_vm.notice)?_c(_vm.notice,{tag:"component"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }